














import Vue from 'vue'
import Component from "vue-class-component"
import Navbar from "@/components/Navbar.vue"
import ContactsModal from '@/components/orders/ContactsModal.vue'
import CartModal from '@/components/orders/CartModal.vue'
import Footer from '@/components/Footer.vue'
import { Prop } from 'vue-property-decorator'
import { customer } from '@/store'

@Component({
  components: {
    Navbar,
    ContactsModal,
    CartModal,
    Footer
  }
})
export default class LayoutPublicProducts extends Vue {
  @Prop() publicUrl!: string

  get retailerPage() {
    return customer.retailerPage
  }

  addScript(scriptText: string) {
    const container = document.createElement('div');
    container.innerHTML = scriptText;

    const insertedNodes = [];

    Array.from(container.children).forEach((el) => {
      el.setAttribute('data-injected-by', 'user-injected');
      document.head.appendChild(el);
      insertedNodes.push(el);
      
    });
  }

  removeScripts() {
    const toRemove = document.head.querySelectorAll(`[data-injected-by="user-injected"]`);
    toRemove.forEach(el => el.remove());
  }

  async mounted() {
    await customer.getRetailerPage(this.publicUrl)
    if (customer.retailerPage) {
      if (customer.retailerPage.avatarFilename) {
        var favicon = document.getElementById("favicon");
        (favicon as any).href = this.getFullImageUrl(customer.retailerPage.avatarFilename)
      }
      if (this.retailerPage && this.retailerPage.embedCode) {
        this.addScript(this.retailerPage.embedCode)
      }      
    }
  }

  getFullImageUrl(filename: string) {
    return `${process.env.VUE_APP_BASE_URL}/pages/uploads/${filename}`
  }
}
